
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.86 3.825h8.17M2.858 6.24l4.828-.024M2.862 8.793l8.17.025M2.86 11.348h6.303M1.43.488v12.886M.93 13.675h11.181M1.43.971h8.568M12.57 14.175V2.798M9.686.867l3.086 2.332","stroke":"currentColor"}})])
          )
        }
      }
    